import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SharedService } from 'src/app/_shared/shared.service';
import { HttpMethod, HttpPlus } from 'src/app/SayTS/http-plus';
import { ISGroup } from 'src/app/SayTS/objects/s-group';

@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.scss']
})
export class AdminUserComponent implements OnInit {

  user: any = {
    fullname: '',
    username: '',
    email: '',
    password: '',
    id_client: null,
    lang: 'cs',
    active: true,
    id_group: null
  };
  dataReady = false;
  isSaving = false;
  isEdit = false;
  disabled = false;
  userId: number | null = null;

  clients: any[] = [];
  groups: ISGroup[] = [];
  languageOptions = [
    { value: 'cs', label: 'Čeština' },
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public shared: SharedService,
    private http: HttpPlus
  ) { }

  async ngOnInit(): Promise<void> {
    this.disabled = !this.shared.rights?.r_edit;
    const idParam = this.route.snapshot.paramMap.get('id_user');
    this.userId = idParam ? parseInt(idParam, 10) : null;
    this.isEdit = !!this.userId;

    // Pre-fill id_client z query string (?id_client=X) — používá se při zakládání
    // uživatele z detailu klienta (admin-client → tlačítko Přidat uživatele).
    if (!this.isEdit) {
      const qpClient = this.route.snapshot.queryParamMap.get('id_client');
      if (qpClient) {
        this.user.id_client = parseInt(qpClient, 10);
      }
    }

    await this.loadData();
  }

  async loadData(): Promise<void> {
    try {
      const [clientsRes, groupsRes]: any = await Promise.all([
        this.shared.getCached(this.http, 'clients/all', HttpMethod.GET),
        this.shared.getCached(this.http, 'getGroups', HttpMethod.POST, {})
      ]);

      this.clients = clientsRes || [];
      this.groups = (groupsRes as any)?.rows?.filter((g: any) => g.module === 'BASE') || [];

      // Pro nového uživatele předvyplnit nejvíce omezenou skupinu (Klient = bez r_close a r_edit)
      if (!this.isEdit && this.user.id_group == null) {
        const klient = this.groups.find((g: any) => !g.r_close && !g.r_edit);
        if (klient) this.user.id_group = klient.id_group;
      }

      if (this.userId) {
        const res: any = await this.http.get('getUser/' + this.userId);
        if (res?.user) {
          const baseGroup = res.groups?.find((g: any) => g.module === 'BASE');
          this.user = {
            ...res.user,
            password: '',
            lang: res.user.lang || 'cs',
            id_group: baseGroup?.id_group || null
          };
        }
      }
      this.dataReady = true;
    } catch (error) {
      this.shared.reportError(error, 'Error loading data');
      this.shared.error('Chyba při načítání dat');
    }
  }

  async onSubmit(): Promise<void> {
    this.isSaving = true;
    try {
      const data: any = {
        fullname: this.user.fullname,
        username: this.user.username,
        email: this.user.email,
        id_client: this.user.id_client,
        lang: this.user.lang,
        active: this.user.active,
        groups: {
          BASE: this.user.id_group
        }
      };

      if (this.user.password) {
        data.password = this.user.password;
      }

      if (this.userId) {
        data.id_user = this.userId;
      }

      const result = await this.http.post('admin/users/save', data);

      if (result) {
        this.shared.success(this.isEdit ? 'Uživatel byl upraven' : 'Uživatel byl vytvořen');
        this.router.navigate(['/admin/users']);
      }
    } catch (error) {
      this.shared.reportError(error, 'Error saving user');
      this.shared.error('Chyba při ukládání uživatele');
    } finally {
      this.isSaving = false;
    }
  }

  goBack(): void {
    this.location.back();
  }
}
